import axios from "axios";
import { ip_back } from "../config";

const headers = () => ({
  headers: { Authorization: localStorage.getItem("token") },
});

function unwrap(response) {
  if (response.data?.status === "error") {
    throw new Error(response.data.message || "Request failed");
  }
  return response.data?.data;
}

export async function submitFixcode(payload) {
  try {
    const response = await axios.post(`${ip_back}api/fixcode`, payload, headers());
    return unwrap(response);
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  }
}

export async function listFixcode() {
  const response = await axios.get(`${ip_back}api/fixcode`, headers());
  return unwrap(response) || [];
}

export async function patchFixcodeStatus(requestId, status) {
  const response = await axios.patch(
    `${ip_back}api/fixcode/${encodeURIComponent(requestId)}`,
    { status },
    headers()
  );
  return unwrap(response);
}
